import React from 'react';
import Icon from '../../../components/AppIcon';

const EnergyLevelSlider = ({ energyLevel, onEnergyChange }) => {
  const energyLevels = [
    { value: 1, label: 'Very Low', icon: 'Battery', color: 'var(--color-muted-foreground)' },
    { value: 2, label: 'Low', icon: 'BatteryLow', color: 'var(--color-secondary)' },
    { value: 3, label: 'Moderate', icon: 'BatteryMedium', color: 'var(--color-primary)' },
    { value: 4, label: 'High', icon: 'BatteryFull', color: 'var(--color-accent)' },
    { value: 5, label: 'Very High', icon: 'Zap', color: 'var(--color-accent)' }
  ];

  const currentLevel = energyLevels?.find(level => level?.value === energyLevel) || energyLevels?.[2];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Energy Level
        </h3>
        <div className="flex items-center space-x-2">
          <Icon name={currentLevel?.icon} size={20} color={currentLevel?.color} />
          <span className="text-sm font-medium text-foreground">
            {currentLevel?.label}
          </span>
        </div>
      </div>
      <div className="relative">
        <input
          type="range"
          min="1"
          max="5"
          step="1"
          value={energyLevel}
          onChange={(e) => onEnergyChange(parseInt(e?.target?.value))}
          className="w-full h-2 bg-muted rounded-md appearance-none cursor-pointer
            [&::-webkit-slider-thumb]:appearance-none
            [&::-webkit-slider-thumb]:w-6
            [&::-webkit-slider-thumb]:h-6
            [&::-webkit-slider-thumb]:rounded-full
            [&::-webkit-slider-thumb]:bg-primary
            [&::-webkit-slider-thumb]:cursor-pointer
            [&::-webkit-slider-thumb]:shadow-therapeutic
            [&::-moz-range-thumb]:w-6
            [&::-moz-range-thumb]:h-6
            [&::-moz-range-thumb]:rounded-full
            [&::-moz-range-thumb]:bg-primary
            [&::-moz-range-thumb]:cursor-pointer
            [&::-moz-range-thumb]:border-0
            [&::-moz-range-thumb]:shadow-therapeutic"
        />
        <div className="flex justify-between mt-2">
          {energyLevels?.map((level) => (
            <button
              key={level?.value}
              onClick={() => onEnergyChange(level?.value)}
              className={`
                flex flex-col items-center space-y-1 transition-therapeutic
                ${energyLevel === level?.value ? 'opacity-100' : 'opacity-40 hover:opacity-70'}
              `}
            >
              <Icon name={level?.icon} size={16} color={level?.color} />
              <span className="text-xs text-muted-foreground hidden sm:block">
                {level?.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EnergyLevelSlider;